import {
  IonCard,
  IonCardHeader,
  IonCardTitle,
  IonCardSubtitle,
  IonCardContent,
  IonGrid,
  IonRow,
  IonCol,
  IonImg,
  IonIcon,
  IonText,
  IonChip,
  IonLabel,
  IonButton
} from '@ionic/react';
import { playOutline } from 'ionicons/icons';
import ReactPlayer from 'react-player/lazy';
import {
  getUrlFromPath,
  capitalize,
  trimString,
  getPrivateFile
} from 'libs/helpers/helper.lib';
import { ReactComponent as DownloadFileIcon } from '../../assets/file_download.svg';
import classes from './style.module.scss';

const ErListItem = ({ erResource, resetErResources, push }) => {
  const _renderLeftColumnArticle = () => {
    if (!erResource.thumbnail) {
      return null;
    }
    return (
      <IonCol size='4' className={classes.leftCol}>
        <IonImg src={getUrlFromPath(erResource.thumbnail)} />
      </IonCol>
    );
  };

  const _renderLeftColumnImage = () => {
    return (
      <IonCol size='4' className={classes.leftCol}>
        <IonImg src={getUrlFromPath(erResource.thumbnail)} />
      </IonCol>
    );
  };

  const _renderLeftColumnVideo = () => {
    return (
      <IonCol size='4' className={classes.leftCol}>
        <ReactPlayer
          url={getUrlFromPath(erResource.video_url)}
          width='100%'
          height='100px'
          controls={false}
          playIcon={<IonIcon color='dark' size='large' icon={playOutline} />}
          stopOnUnmount={true}
          className={classes.reactPlayer}
          config={{
            youtube: {
              playerVars: {
                showinfo: 0,
                modestbranding: 1,
                rel: 0
              }
            }
          }}
          {...(erResource.thumbnail && {
            light: getUrlFromPath(erResource.thumbnail)
          })}
        />
      </IonCol>
    );
  };

  const _renderLeftColumnFile = () => {
    return (
      <IonCol size='4'>
        <IonButton
          fill='clear'
          className={classes.downloadIconBox}
          onClick={() => getPrivateFile(erResource.file, erResource.name)}
        >
          <DownloadFileIcon />
        </IonButton>
      </IonCol>
    );
  };

  const _renderLeftColumn = () => {
    switch (erResource.type) {
      case 'article':
        return _renderLeftColumnArticle();
      case 'image':
        return _renderLeftColumnImage();
      case 'video':
        return _renderLeftColumnVideo();
      case 'file':
        return _renderLeftColumnFile();
      default:
        return '';
    }
  };
  return (
    <IonCard
      key={erResource.id}
      color='dark'
      className={classes.ionCard}
      button
      onClick={() => push(`/educational-resources/${erResource.id}`)}
    >
      <div className={classes.mainContainer}>
        <IonGrid>
          <IonRow>
            <IonCol className={classes.ionColNoPad}>
              <IonCardHeader className={classes.headContainer}>
                <IonCardTitle className={classes.erTitle}>
                  {capitalize(erResource.name)}
                </IonCardTitle>
                <IonCardSubtitle className={classes.erSubTitle}>
                  {erResource.er_categories
                    ?.map((er) => capitalize(er.name))
                    .join(', ')}
                </IonCardSubtitle>
              </IonCardHeader>
              <IonCardContent>
                <IonText className={classes.description}>
                  {trimString(erResource.description, 60)}
                </IonText>
                <IonText className={classes.author}>
                  <span className={classes.createdBy}>Created By</span>
                  <span className={classes.authorName}>
                    {erResource.createdBy?.user.first_name}{' '}
                    {erResource.createdBy?.user.last_name}
                  </span>
                </IonText>
              </IonCardContent>
            </IonCol>
            {_renderLeftColumn()}
          </IonRow>
        </IonGrid>
      </div>
      <div className={classes.tagContainer}>
        <IonCardContent>
          <span className={classes.hash}> &#x23;</span>
          {erResource.er_tags?.map((er) => (
            <IonChip
              key={`${erResource.id}_${er.id}`}
              onClick={(e) => {
                e.stopPropagation();
                push(`/educational-resources/tag/${er.id}?title=${er.name}`);
              }}
            >
              <IonLabel>{er.name}</IonLabel>
            </IonChip>
          ))}
        </IonCardContent>
      </div>
    </IonCard>
  );
};

export default ErListItem;
